import { Skeleton } from '@/components/ui/skeleton'
import { cn } from '@/lib/utils'

type AdminFormSkeletonProps = {
  fields?: number
  className?: string
}

/** Form / flag / FAQ editor loading placeholder. */
export function AdminFormSkeleton({
  fields = 4,
  className,
}: AdminFormSkeletonProps) {
  return (
    <div
      className={cn('flex flex-col gap-4', className)}
      role="status"
      aria-label="Loading form"
    >
      {Array.from({ length: fields }).map((_, i) => (
        <div
          key={i}
          className="space-y-2 rounded-2xl border border-border bg-card p-4"
        >
          <div className="flex items-center justify-between gap-3">
            <Skeleton className="h-4 w-32" />
            <Skeleton className="h-6 w-11 rounded-full" />
          </div>
          <Skeleton className="h-3 w-full max-w-md" />
          <Skeleton className="h-8 w-full rounded-lg" />
        </div>
      ))}
      <span className="sr-only">Loading…</span>
    </div>
  )
}
